const APP_CONFIG = {
  version: "7.86.0",
  title: "Claire V7.86.0",
  version_client: "7.86.0",
};

export default APP_CONFIG;
